import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { IconButton, Tooltip, Typography, withStyles, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import { localization, getDimensionsOfPagination } from '../../../sc-utilities';
import * as actions from '../store/historyActions';
import * as action from '../../../np-core/Auth/store/authActions';
import Toolbar from '../../../sc-utilities/Toolbar';
import { MuiTableRows } from '../../../../themes';
import { Refresh } from '@material-ui/icons';

const styles = theme => ({
    "@global": {
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    }
});

let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const ErasureHistoryList = props => {
    const { classes, translations, fetching, fetchErasureHistory, fetchErasureHistoryCount, loading, saveColumnsFilter, activeCustomerID, tableColumns, productID, tableRef } = props;
    const columnObject = useMemo(() => tableColumns
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);
    const [tableOptions, setTableOptions] = useState({
        filtering: true,
        sorting: false,
        selection: false,
        search: false,
        minBodyHeight: window.innerHeight - 310 < 300 ? 300 : window.innerHeight - 310,
        maxBodyHeight: window.innerHeight - 310,
        pageSizeOptions: rowsPageSizeInit,
        exportButton: false,
        rowStyle: (_rowData, index) => {
            return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
        },
        columnsButton: true,
        pageSize: pageSize ? pageSize : 50,
        emptyRowsWhenPaging: false
    });

    const filterQuery = filters => {
        let obj = {};
        obj['ProductID'] = productID;
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }


    async function fetchTableData(query) {
        let q = filterQuery(query.filters);
        
        query['ActiveCustomerID'] = activeCustomerID;
        query['q'] = q;
        let count = await fetchErasureHistoryCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await fetchErasureHistory(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const tableTitle = () => {
        return (
            <div className={classes.tableTitle}>
                <Typography className={classes.typography}>{translations['erasure_history'] || 'Erasure history'}</Typography>
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`ErasureHistory`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    }

    return (
        <Paper>
            <MaterialTable
                components={{
                    Toolbar: props => (
                        <Toolbar data={props} selectedRows={props.selectedRows} translations={translations} />
                    )
                }}
                tableRef={tableRef}
                title={tableTitle()}
                columns={columnObject}
                data={fetchTableData}
                options={tableOptions}
                isLoading={loading}
                localization={localization(translations)}
                onChangeRowsPerPage={(size) => {
                    pageSize = size
                }}
                onChangeColumnHidden={columnHidden}
                onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
            />
        </Paper>
    );
};


const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        loading: state.product.histories.erasure.loading,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchErasureHistoryCount: (filter) => dispatch(actions.fetchErasureHistoryCount(filter)),
        fetchErasureHistory: (filter) => dispatch(actions.fetchErasureHistory(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ErasureHistoryList));